import { Injectable } from "@angular/core";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { AbstractParser } from "../../parser";
import { parseClusters } from "./cluster-functions";

@Injectable()
export class ClustersPageableResultParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const clusterPageableResult = new PageableResult();
    clusterPageableResult.setStart(payload.Start);
    clusterPageableResult.setTotalItems(payload.Total);
    clusterPageableResult.setItems(parseClusters(payload.Data));

    return clusterPageableResult;
  }
}
